import React, { useEffect } from 'react'
import { RouteComponentProps, useLocation, useHistory } from 'react-router-dom';
import { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import CompanyEdit from './edit';

type PageEditCompanyProps = RouteComponentProps<any>;

export const CompanyDetail = (props: PageEditCompanyProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [currentEditCompany] = useGlobal<IGlobalState, 'currentEditCompany'>('currentEditCompany');
    const oidIndex = location.pathname.lastIndexOf('/')
    const oid = parseInt(location.pathname.substring(oidIndex + 1))
    
    //TODO
    console.log('Company id is: ' + oid);
    const company = currentEditCompany?.company;

    useEffect(() => {
        // Il seguente è per non eseguire cambio di pagina durante il render
        if(!company) 
            history.push('/company');
    }, [company, history])

    const initialMode = oid > 0 ? InEditingMode.Edit : InEditingMode.New;
    return ( 
        <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
            <IForfettariAppBar title="Company" handleLoad={() => {}}></IForfettariAppBar>
            <Main>
                <CompanyEdit initialMode={initialMode} /> 
            </Main>
        </div>    
    )
}




